import React from 'react'
import { useTranslation } from 'react-i18next'
import { b2bMarketFlag, b2bMarketLabel } from '../../utils/b2bMarketDisplay'

type TotalsSectionProps = {
    total: string
    note: string
    markets: Array<{ code: string; widthPct: number; value: string }>
    onViewAllAgencies: () => void
}

export const TotalsSection: React.FC<TotalsSectionProps> = ({ total, note, markets, onViewAllAgencies }) => {
    const { t } = useTranslation('dashboard')
    return (
    <section className="flex flex-col gap-3">
        <div className="flex items-baseline gap-2.5 flex-wrap">
            <h2 className="text-[17px] font-semibold tracking-tight text-neutralBlack-900">{t('metrics.totalsTitle')}</h2>
            <span className="text-[13px] text-neutralBlack-600">{t('metrics.totalsSubtitle')}</span>
        </div>

        <div className="bg-white rounded-2xl p-5 border border-neutralBlack-200 shadow-sm flex items-center gap-7 flex-wrap">
            <div className="flex-none flex flex-col gap-1.5 min-w-[170px]">
                <span className="text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-500">{t('metrics.totalAgencies')}</span>
                <span className="text-[30px] font-semibold tracking-tight text-neutralBlack-900">{total}</span>
                <span className="text-[12.5px] text-neutralBlack-600">{note}</span>
            </div>
            <div className="flex-1 min-w-[260px] flex flex-col gap-2.5">
                {markets.map((m) => {
                    const flag = b2bMarketFlag(m.code)
                    return (
                        <div key={m.code} className="flex items-center gap-2.5">
                            {flag ? (
                                <img src={flag} alt={m.code} className="w-4 h-3 flex-none rounded-sm object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.08)]" />
                            ) : (
                                <span className="w-4 h-3 flex-none rounded-sm bg-neutralBlack-100" />
                            )}
                            <span className="w-16 flex-none text-xs text-neutralBlack-600">{b2bMarketLabel(m.code)}</span>
                            <span className="flex-1 min-w-0 h-[5px] rounded-full bg-neutralBlack-100 overflow-hidden">
                                <span className="block h-[5px] rounded-full bg-neutralBlack-900" style={{ width: `${m.widthPct}%` }} />
                            </span>
                            <span className="min-w-[40px] text-right text-[13px] text-neutralBlack-800">{m.value}</span>
                        </div>
                    )
                })}
            </div>
            <button type="button" onClick={onViewAllAgencies} className="flex-none text-[13px] text-neutralBlack-900 underline underline-offset-2 hover:no-underline">
                {t('metrics.viewAllAgencies')}
            </button>
        </div>
    </section>
    )
}
